import React from 'react'
import { Dropdown } from '@contrast-security-inc/design-system-inputs'
import { SingleSelectComboboxString } from '../../../legacy-design-system/combobox'
import { LogLevel } from '../../servers-grid/shared'
import { ContrastFormattedMessage } from '../../contrast-formatted-message'
import { useIntl } from 'react-intl'

export type LogLevelDisplay = 'Debug' | 'Error' | 'Info' | 'Trace' | 'Warn'

const logLevelToDisplayValue: (logLevel: LogLevel) => LogLevelDisplay = (
  logLevel
) => {
  switch (logLevel) {
    case 'DEBUG':
      return 'Debug'
    case 'ERROR':
      return 'Error'
    case 'INFO':
      return 'Info'
    case 'TRACE':
      return 'Trace'
    case 'WARN':
      return 'Warn'
  }
}

export function LogLevelInput({
  value,
  edited,
  onChange,
  isReadOnly
}: {
  value?: LogLevel
  edited: boolean
  onChange: (value: LogLevel) => void
  isReadOnly?: boolean
}) {
  return (
    <ContrastFormattedMessage id="title_logLevel">
      {(labelLogLevel) => (
        <SingleSelectComboboxString<LogLevel>
          id="serverSettings_logLevel"
          label={labelLogLevel}
          items={[
            {
              items: ['ERROR', 'WARN', 'INFO', 'DEBUG', 'TRACE']
            }
          ]}
          itemToString={logLevelToDisplayValue}
          value={value}
          onChange={onChange}
          edited={edited}
          disabled={isReadOnly}
        />
      )}
    </ContrastFormattedMessage>
  )
}

export function DiagnosticCollectionLogLevelInput({
  value,
  onChange,
  isReadOnly
}: {
  value?: LogLevel
  onChange: (value: LogLevel) => void
  isReadOnly?: boolean
}) {
  const { formatMessage } = useIntl()
  return (
    <Dropdown<LogLevel>
      label={formatMessage({
        id: 'title_diagnosticCollectionLogLevel'
      })}
      items={['DEBUG', 'TRACE']}
      value={value}
      onChange={(_evt, logLevel: LogLevel) => {
        onChange(logLevel)
      }}
      isDisabled={isReadOnly}
      isRequired={true}
      itemToString={logLevelToDisplayValue}
    />
  )
}
